module.exports = __webpack_public_path__ + "img/70m1.b91792f9.jpg";